import { useVirtualizer } from '@tanstack/react-virtual';
import { useContext, useMemo, useRef } from 'react';
import { ReportingHistoryItem } from './components/reporting-history-item/reporting-history-item';
import { TaxSummaryContext, TaxSummaryProvider } from './state/tax-summary-context';
import { AbsolutePosDiv, HistoryList, RelativePosDiv } from './styles';
import { ReportingHistoryProps } from './types/reporting-history-types';
import { sortPaymentPeriodsByDate } from './utils/sort-payment-periods-by-date';

function ReportingHistoryComponent(props: ReportingHistoryProps) {
  const { data, ...other } = props;

  const { closeAllTaxSummaries } = useContext(TaxSummaryContext);

  const ref = useRef<HTMLDivElement>(null);

  const reportingHistoryData = useMemo(() => {
    closeAllTaxSummaries();
    return sortPaymentPeriodsByDate(data);
  }, [closeAllTaxSummaries, data]);

  const virtualizer = useVirtualizer({
    count: reportingHistoryData.length,
    getScrollElement: () => ref.current,
    estimateSize: () => 300, // This is some arbitrary value. "virtualizer.measureElement" handles dynamic sizing
  });

  const items = virtualizer.getVirtualItems();

  return (
    <HistoryList ref={ref}>
      <RelativePosDiv height={virtualizer.getTotalSize()}>
        <AbsolutePosDiv start={items[0]?.start ?? 0}>
          {items.map((vRow) => (
            <div key={vRow.index} data-index={vRow.index} ref={virtualizer.measureElement}>
              <ReportingHistoryItem {...reportingHistoryData[vRow.index]} {...other} />
            </div>
          ))}
        </AbsolutePosDiv>
      </RelativePosDiv>
    </HistoryList>
  );
}

export function ReportingHistory(props: ReportingHistoryProps) {
  return (
    <TaxSummaryProvider>
      <ReportingHistoryComponent {...props} />
    </TaxSummaryProvider>
  );
}